import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as StartVmixServerActions from '../actions/start-vmix-server.actions';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ProductionInstancesService} from '../../../services/api/production-instances/production-instances.service';
import {UUID} from '../../../shared/types/uuid.type';
import {ProductionInstance} from '../../../services/api/production-instances/production-instance.model';


@Injectable()
export class StartVmixServerEffects {

  // noinspection JSUnusedGlobalSymbols
  startProductionInstance = createEffect(() => {
    return this.actions.pipe(
      ofType(StartVmixServerActions.startVmixServer),
      concatMap((payload: { id: UUID }) =>
        this.productionInstancesService.start(payload.id)
          .pipe(
            map((data: ProductionInstance) => StartVmixServerActions.startVmixServerSuccess({data})),
            catchError((error: any) => of(StartVmixServerActions.startVmixServerFailure({error})))
          )
      )
    );
  });

  // noinspection JSUnusedGlobalSymbols
  startProductionInstanceSuccess = createEffect(() => {
    return this.actions.pipe(
      ofType(StartVmixServerActions.startVmixServerSuccess),
      tap(() => this.snackBar.open('Production instance successfully started', 'Success', {duration: 3000}))
    );
  }, {dispatch: false});

  constructor(
    private readonly actions: Actions,
    private readonly productionInstancesService: ProductionInstancesService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
